export const THREE_DS_MESSAGE_TYPES = {
  COMPLETE: "BAMBORA_3DS_COMPLETE",
  CLOSE: "BAMBORA_3DS_CLOSE",
  TIME_OUT:"BAMBORA_3DS_TIME_OUT",
} as const

export const THREE_DS_STATUSES={
  ATTEMPTED: "Attempted",
  SUCCEEDED: "Succeeded",
  PENDING_CHALLENGE:"PendingChallenge",
  PENDING_METHOD: "PendingMethod",
  UNAVAILABLE:"Unavailable",
  REJECTED: "Rejected",
  FAILED: "Failed",
  ERROR: "Error",
  NOT_SUPPORTED: "NotSupported"
} as const

// EMVCo challenge window sizes. The value we send on the AuthRequest must match
// the size of the modal/iframe that renders the ACS challenge, otherwise the
// bank page is laid out for the wrong viewport and looks cramped/clipped.
// 01 = 250x400, 02 = 390x400, 03 = 500x600, 04 = 600x400, 05 = full screen.
export const THREE_DS_CHALLENGE_WINDOW_SIZE = {
  COMPACT: '03', // 500x600 — desktop modal
  FULL_SCREEN: '05', // full screen — mobile
} as const
